/**
 * Select — primitive de controle dropdown.
 *
 * Pas de prop `label` / `error` — toujours wrappe par <Field> ou <FormSelect>.
 */
import { forwardRef, type SelectHTMLAttributes } from 'react'

type SelectProps = SelectHTMLAttributes<HTMLSelectElement> & {
  placeholder?: string
}

const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, placeholder, children, ...rest },
  ref,
) {
  const classes = ['ui-select', className].filter(Boolean).join(' ')
  return (
    <select ref={ref} className={classes} {...rest}>
      {placeholder && (
        <option value="" disabled hidden>
          {placeholder}
        </option>
      )}
      {children}
    </select>
  )
})

export default Select
